import React from 'react'
import { graphql } from 'gatsby'
import { Tool } from './mapper'
import BaseCardList from '../../ui/baseCardList'

type FirmToolsProps = {
  tools: Tool[] | null
}

const FirmTools: React.FC<FirmToolsProps> = ({ tools }) => {
  if (!tools || tools?.length === 0) {
    return null
  }

  return (
    <BaseCardList
      title="Nos outils"
      items={tools.map((tool) => ({
        name: tool?.name as string,
        logoUrl: tool?.logo as string,
        logo: tool?.logo as string,
        link: `/outils/${tool?.slug}`,
      }))}
    />
  )
}

export default FirmTools

export const query = graphql`
  fragment FirmTools on STRAPI_ACCOUNTING_FIRM {
    accountingTools {
      name
      id
      logo {
        localFile {
          extension
          url
        }
      }
      permalink
    }
  }
`
